export default "__VITE_ASSET__lf9NdCZ0__"